import { map } from 'lodash'
import config from '../../config'
import { ResourceKey, MenuPermission } from './type'
import { RolePermission } from '../../resources/roles-permissions/type'
const defaultResourceObj = { key: null, resource: null }
const transformResourceKeyConfig = (): ResourceKey[] =>
  map(config('resources.keys'), (value, prop) => ({ key: value, resource: prop.toString() }))

const transformMenuPermission = (permission: RolePermission): MenuPermission => {
  return {
    resourceName:
      transformResourceKeyConfig().find((m) => m.key === permission.key) || defaultResourceObj,
    title: { th: permission.name_th, en: permission.name_en },
    childs: [],
  }
}
const filterAvailable = (permissions): RolePermission[] =>
  permissions.filter((menu) => menu.readable || menu.readable === null)

export const transformMenu = (permissions: RolePermission[]): MenuPermission[] => {
  return filterAvailable(permissions).reduce((menus, permission) => {
    const { resourceName = defaultResourceObj, title } = transformMenuPermission(permission)

    const filteredSubMenus = filterAvailable(permission.sub_menu)
      .map(transformMenuPermission)
      .filter((menu) => menu.resourceName.key !== null)

   

    if (resourceName.key !== null || filteredSubMenus.length > 0) {
      menus.push({
        resourceName,
        title,
        childs: filteredSubMenus,
      })
    }
    return menus
  }, [])
}
